import AddIcon from '@material-ui/icons/Add'
import { ButtonType } from '../../../model/button'

import { componentBoxShowAction } from 'src/reducers/component-box/action'
import {
  AddMember,
  ImportMembers,
} from 'src/pages/collection/components/collection-page-view/components/learners/components/teams-member-list/components'
import ComponentBoxContent from 'src/model/component-box'
import { teamsMemberExportAction } from 'src/reducers/teams/action'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import { messageBoxShowAction } from 'src/reducers/message-box/action'
import CollectionSelectionModal from 'src/components/collection-select-modal'

const actions = [
  {
    label: '',
    items: [
      {
        label: 'Create learner',
        type: ButtonType.NORMAL,
        icon: <AddIcon />,
        variant: 'contained',
        link: null,
        size: 'small',
        exec: (entity, dispatch, refresh) => {
          dispatch(
            componentBoxShowAction(
              new ComponentBoxContent(
                <AddMember entity={entity} dispatch={dispatch} />,
                {
                  hideCloseButton: false,
                },
              ),
            ),
          )
        },
        disabled: entity => {
          return false
        },
        hidden: entity => {
          return false
        },
      },
    ],
  },

  // New popover action group
  {
    label: 'Bulk Actions',
    items: [
      {
        label: 'Export List',
        type: ButtonType.NORMAL,
        link: null,
        exec: (entity, dispatch, refresh, query) => {
          dispatch(teamsMemberExportAction(query.TeamsId, null))
        },
        disabled: entity => {
          return false
        },
        hidden: entity => {
          return false
        },
      },
      {
        label: 'Import List',
        type: ButtonType.NORMAL,
        link: null,
        exec: (entity, dispatch, refresh) => {
          dispatch(
            componentBoxShowAction(
              new ComponentBoxContent(
                <ImportMembers entity={entity} dispatch={dispatch} />,
                {
                  hideCloseButton: false,
                },
              ),
            ),
          )
        },
        disabled: entity => {
          return false
        },
        hidden: entity => {
          return false
        },
      },
      {
        label: 'Link from collection',
        type: ButtonType.NORMAL,
        link: null,
        exec: (entity, dispatch, refresh, query) => {
          dispatch(
            messageBoxShowAction(
              MessageBoxContent({
                type: MessageBoxType.WARNING,
                buttons: [],
                title: 'Link from collection',
                description:
                  'Dynamically import learners from another collection, and any updates to the student list will be reflected. Just select the collection to import from.',
                draggable: false,
                component: <CollectionSelectionModal id={query.Id} />,
                maxWidth: '720px',
              }),
            ),
          )
        },
        disabled: entity => {
          return entity.length === 0
        },
        hidden: 'returnFalseIfAccessValueIs2',
      },
    ],
  },
]

export default actions
